var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1776_6296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1776_6296)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62332 15.5409C2.94943 15.867 3.34165 16.03 3.79999 16.03H7.29999V14.3634H3.79999V3.53003H12.1333V13.03H13.8V3.53003H14.6333V1.86336H10.4667V1.03003H5.46665V1.86336H1.29999V3.53003H2.13332V14.3634C2.13332 14.8217 2.29665 15.2142 2.62332 15.5409ZM7.13332 12.6967H5.46665V5.1967H7.13332V12.6967ZM10.4667 12.6967H8.79999V5.1967H10.4667V12.6967Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1411 14.03C9.12221 14.03 8.29999 14.8543 8.29999 15.8712V18.3816C8.29999 18.7052 8.56233 18.9675 8.88593 18.9675C9.20952 18.9675 9.47186 18.7052 9.47186 18.3816V17.7123H10.8104V18.3816C10.8104 18.7052 11.0728 18.9675 11.3964 18.9675C11.7199 18.9675 11.9823 18.7052 11.9823 18.3816V15.8712C11.9823 14.8522 11.1578 14.03 10.1411 14.03ZM9.47186 16.5404V15.8712C9.47186 15.5001 9.77206 15.2019 10.1411 15.2019C10.5107 15.2019 10.8104 15.5005 10.8104 15.8712V16.5404H9.47186Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8733 17.7957H14.204V14.616C14.204 14.2924 13.9416 14.03 13.618 14.03C13.2944 14.03 13.0321 14.2924 13.0321 14.616V18.3816C13.0321 18.7052 13.2944 18.9675 13.618 18.9675H14.8733C15.1969 18.9675 15.4592 18.7052 15.4592 18.3816C15.4592 18.058 15.1969 17.7957 14.8733 17.7957Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0113 17.7957H17.342V14.616C17.342 14.2924 17.0796 14.03 16.756 14.03C16.4324 14.03 16.1701 14.2924 16.1701 14.616V18.3816C16.1701 18.7052 16.4324 18.9675 16.756 18.9675H18.0113C18.3349 18.9675 18.5972 18.7052 18.5972 18.3816C18.5972 18.058 18.3349 17.7957 18.0113 17.7957Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteAll);
export default __webpack_public_path__ + "static/media/ic-delete-all.2c5c737cf25b175ffa77fb465dfafa79.svg";
export { ForwardRef as ReactComponent };